import { isNil } from 'lodash';

import type {
  ActionButtonDropdownElementInfo,
  ActionButtonDropdownItem,
  ActionButtonDropdownItemProps
} from 'types';

import { getElementInfo } from 'utils/element';

export const getElementDetails = (ref?: HTMLElement | null): ActionButtonDropdownElementInfo | undefined | null => {
  const elementInfo = getElementInfo(ref);

  return elementInfo && {
    bottom: elementInfo.bottom,
    left: elementInfo.left,
    right: elementInfo.right,
    width: elementInfo.width,
    height: elementInfo.height
  };
};

export const getUpdatedItem = (items: Array<ActionButtonDropdownItem>, identifier: string): ActionButtonDropdownItem | undefined => {
  const updatedItem = items.find(item => item.identifier === identifier);

  if (isNil(updatedItem)) {
    return undefined;
  }

  return {
    ...updatedItem,
    isSelected: true
  };
};

export const updatePropValueByIdentifier = (
  items: Array<ActionButtonDropdownItem>,
  identifier: string | undefined,
  prop: ActionButtonDropdownItemProps
): Array<ActionButtonDropdownItem> => (items || []).map(item => ({
  ...item,
  [String(prop)]: item.identifier === identifier || item[prop]
}));

export const deselectAllItems = (items: Array<ActionButtonDropdownItem>): Array<ActionButtonDropdownItem> => (items || []).map(item => ({
  ...item,
  isSelected: false
}));
